<script>
  import EditalService from '../../../../domain/edital/services/edital'
  import { isArray } from 'lodash'
  import CKEditor from 'ckeditor4-vue'
  import Vue from 'vue'

  Vue.use(CKEditor)

  export default {
    nome: 'novo-edital',
    data () {
      return {
        isLoading: false,
        isLoaded: false,
        cadastroError: null,
        atualizadoSucesso: null,
        data: {
          id: null,
          nome: null,
          texto: null
        },
        editorConfig: {
          height: 300,
          language: 'pt-BR',
          colorButton_enableMore: false,
          contentsLangDirection: 'ltr',
          toolbar: 'Full',
          disableNativeSpellChecker: false,
          resize_enabled: false,
          uiColor: '#E9E9E9',
          toolbar_Full:
          [
            ['Maximize', 'Preview'], ['Source'],

            ['Undo', 'Redo', 'SelectAll'],
            ['NumberedList', 'BulletedList', '-', 'Outdent', 'Indent'],
            ['Link', 'Unlink'],

            ['Font', 'FontSize'],
            '/',
            ['Bold', 'Italic', 'Underline', 'Strike', '-', 'Subscript', 'Superscript'],

            ['JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock'],
            ['Image', 'Table', 'HorizontalRule', 'Smiley', 'SpecialChar'],

            ['TextColor', 'BGColor']
          ]
        }
      }
    },
    computed: {
    },
    created () {
      this.$route.params.id && this.start() || this.carregarTextoEdital(this.$route.query)
    },
    activated () {
    },
    destroyed () {
    },
    watch: {},
    methods: {
      start () {
        // if (this.$route.params.id) {
        this.$loaderOverlay.open().message('Carregando')
        EditalService.find(this.$route.params.id)
            .then((response) => {
              this.isLoaded = true
              this.$loaderOverlay.hide()
              this.data = response.data
              console.log(response)
            })
            .catch((response) => {
              this.$loaderOverlay.hide()
              console.log(response)
            })
        /* } else {
          this.isLoaded = true
          // this.$loaderOverlay.open().message('Aguarde')
        } */
      },
      submit () {
        this.cadastroError = null
        this.atualizadoSucesso = false
        this.$loaderOverlay.open().message('Processando...')
        this.$bar.start()
        window.setTimeout(() => {
          this.$loaderOverlay.message('Aguarde...')
        }, 1000)
        EditalService.cadastrar(this.data, this.$route.query).then((response) => {
          let callbackEnd = () => {
            this.$bar.finish()
            this.$loaderOverlay.hide()
            if (this.$route.params.id) {
              // Continua na mesma tela de edição
              // this.$nextTick(() => {
              this.start()
              this.atualizadoSucesso = true
              this.$el.querySelector('#sucessMsg').focus()
              // })
            } else {
              // Redirecionr para tela de visualização
              // this.$router.push({name: 'documento.editar', params: {id: response.data.id}})
              this.atualizadoSucesso = true
              this.$el.querySelector('#sucessMsg').focus()
            }
          }
          callbackEnd()
        }).catch((response) => {
          this.$bar.finish()
          this.$loaderOverlay.hide()
          this.cadastroError = response.data.errors
          this.$nextTick(() => {
            this.$refs.error.focus()
          })
          console.log(response)
        })
      },
      carregarTextoEdital ({leilao, tipo}) {
        this.$loaderOverlay.open().message('Carregando texto do edital...')
        EditalService.getTextoEdital(leilao, tipo)
          .then(response => {
            this.data = response.data
            this.data.tipo = tipo
            this.data.leilao = leilao
            this.$loaderOverlay.hide()
            this.isLoaded = true
          })
          .catch(error => {
            this.$loaderOverlay.hide()
            // console.log(this.printError(error.data && error.data.error))
            console.log(error)
            this.isLoaded = true
          })
      },
      printError (err) {
        if (isArray(err)) {
          return err[0]
        }
        return err
      }
    }
  }
</script>

<template>
  <transition name="slide">
    <div v-if="isLoaded" class="content-transition">
      <div class="bg-light lter b-b wrapper-md">
        <div class="row">
          <div class="col-sm-6"><h1 class="m-n font-thin h3">Cadastro de Edital</h1></div>
          <div class="col-sm-6">
            <router-link :to="{name: 'edital.list'}"
                         class="pull-right hidden-print" style="clear: left"><strong class="label no-radius bg-info">Voltar</strong>
            </router-link>
          </div>
        </div>
      </div>
      <div class="wrapper-md">
        <div class="panel panel-default">
          <div class="panel-body">
            <div tabindex="-1" ref="error" v-if="cadastroError !== null" class="alert alert-danger">
              <div class="m-b-sm font-bold">Erro ao registrar, corrija e tente novamente</div>
              <p v-for="(erro, key) in cadastroError">{{printError(erro)}}</p>
            </div>
            <a name="sucessMsg" id="sucessMsg" href="javascript:void(0)" ref="sucessMsg"></a>
            <div tabindex="-1" ref="error" v-if="atualizadoSucesso !== null && atualizadoSucesso" class="alert alert-success">
              <div class="font-bold">{{$route.params.id && 'Atualizado' || 'Cadastrado'}} com sucesso!</div>
            </div>
            <form @submit.prevent.stop="" class="bs-example form-horizontal">

              <div class="form-group">

                <div class="col-sm-12">
                  <label class="control-label">Nome</label>
                  <input type="text" class="form-control" v-model="data.nome"/>
                </div>
              </div>

              <div class="form-group">
                <div class="col-sm-12">
                  <label class="control-label">Conteúdo do edital</label>
                  <!-- <vue-editor id="editor" v-model="data.texto" style="max-height: 500px; overflow: auto;"></vue-editor> -->
                  <ckeditor v-model="data.texto" :config="editorConfig"></ckeditor>
                  <!-- <textarea type="text" class="form-control" v-model="data.texto"></textarea> -->
                </div>
              </div>

              <div class="clearfix"></div>

              <hr>
              <div class="row wrapper">
                <u-button @click="submit" class="btn m-b-xs w-xs btn-info m-r-xs">
                  <span v-if="!data.id">Cadastrar</span>
                  <span v-if="data.id">Atualizar</span>
                </u-button>
                <u-button class="btn m-b-xs w-xs m-r-xs btn-default" @click="$router.push({name: 'edital.list'})">Cancelar</u-button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>



// WEBPACK FOOTER //
// NovoEdital.vue?8af27b12